

export class Form {
  constructor() {
    const forms: NodeListOf<HTMLFormElement> = document.querySelectorAll('form')

    forms?.forEach(form => {
      form.addEventListener('input', (event) => {
        const element = event.target as HTMLInputElement;

        if (element.type === 'checkbox') {
          const allCheckboxes: NodeListOf<HTMLInputElement> = form.querySelectorAll(`[name="${element.name}"]`);
          let oneRequired = false;
          let oneChecked = false;

          allCheckboxes?.forEach(checkbox => {
            if (checkbox.required) {
              oneRequired = true;
            }

            if (checkbox.checked) {
              oneChecked = true;
            }
          });

          if (oneRequired) {
            allCheckboxes?.forEach(checkbox => {
              checkbox.required = false;

              if (checkbox.checked) {
                checkbox.required = true;
              }
            });

            console.log(!Array.from(allCheckboxes)?.find(element => element.required));

            if (!element.checked && !Array.from(allCheckboxes)?.find(element => element.required)) {
              element.required = true;
            }
          }
        }
      });
    });
  }
}
